import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import OrderServices from "../based/services/OrderServices";

function PrintReturnLabelModal({ show, onClose, orderId }) {
    const [warehouseCode, setWarehouseCode] = useState("");
    const [selectedProducts, setSelectedProducts] = useState([]);

    console.log("selectedProducts", selectedProducts);

    useEffect(() => {
        if (show && orderId) {
            fetchModel(orderId);
        }
    }, [show, orderId]);

    const fetchModel = async (orderId) => {
        const [err, data] = await OrderServices.GetOrderReturnManageModelsById(orderId);
        if (!err && data) {
            let dt = { ...data };
            let products = dt.orderReturnProductManageModels || [];
            let filterReturnProducts = products.filter((p) => p.isReturnDefective);
            if (filterReturnProducts && filterReturnProducts.length > 0) {
                let first = filterReturnProducts[0];
                first.isActive = true; // Set the first product as active by default
            }
            setSelectedProducts(filterReturnProducts);
        } else {
            setSelectedProducts([]);
        }
    };

    const warehouseLocations = [
        { code: "A12 - CG4W", active: true },
        { code: "A12 - 235G", active: false },
        { code: "B1 - AC45", active: true },
        { code: "B2 - FR2A", active: false },
    ];

    const handlePrintPDF = (fileLink) => {
        //kiểm tra iframe
        let iframe = document.getElementById("print_pdf");
        if (!iframe) {
            iframe = document.createElement("iframe");
            iframe.id = "print_pdf";
            iframe.name = "print_pdf";
            iframe.style.display = "none";
        }

        iframe.src = fileLink;
        iframe.onload = () => {
            iframe.contentWindow.addEventListener("afterprint", (evt) => {
                console.log("printed");
                document.body.removeChild(iframe);
            });

            window.frames["print_pdf"].focus();
            window.frames["print_pdf"].print();
        };
        document.body.appendChild(iframe);
    };

    const handlePrintLabelAndStorage = async () => {
        let activeProduct = selectedProducts.find((p) => p.isActive);
        if (activeProduct) {
            const [err, data] = await OrderServices.HandlePrintLabelAndStorage(activeProduct);
            if (!err && data) {
                let lst = [...selectedProducts];
                let item = lst.find((p) => p.id === activeProduct.id);
                item.barcodeUrl = data;
                setSelectedProducts(lst);
                handlePrintPDF(data);
            }
        }
    };

    const handleReprintLabel = (productId) => {
        console.log("Reprinting label for product:", productId);
    };

    const activeProduct = useMemo(() => {
        let index = selectedProducts.findIndex((product) => product.isActive);
        if (index === -1) return null; // No active product found
        let item = selectedProducts[index];
        item.index = index + 1;
        return item;
    }, [selectedProducts]);

    return (
        <CommonModal show={show} onClose={onClose} title="In Tem và cho sản phẩm vào kệ" size="lg">
            <Wrapper>
                <div className="modal-container-custom">
                    <div className="modal-content-custom">
                        <div className="left-section">
                            <div className="instruction-text">Hãy in tem & dán cho từng nhóm một</div>
                            <div className="group-info-section">
                                <div className="group-header">
                                    <span className="group-label">Nhóm: </span>
                                    {selectedProducts && activeProduct && (
                                        <span className="group-number">
                                            {activeProduct.index}/{selectedProducts.length}
                                        </span>
                                    )}
                                    <span className="group-status">{activeProduct && activeProduct.returnProductStatusString}</span>
                                </div>
                            </div>

                            {activeProduct && (
                                <>
                                    <div className="product-showcase">
                                        <div className="product-images">
                                            {activeProduct.frontImage && <img src={activeProduct.frontImage} alt="Product 1" />}
                                            {activeProduct.backImage && <img src={activeProduct.backImage} alt="Product 1" />}
                                        </div>
                                        <div className="product-title">{activeProduct.productTitle}</div>
                                    </div>

                                    <div className="product-details">
                                        <div className="detail-item">
                                            <span className="detail-label">{activeProduct.appProductName}</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-label">{activeProduct.color}</span>
                                        </div>
                                        <div className="detail-item size">
                                            <span className="detail-value">{activeProduct.size}</span>
                                        </div>
                                        <div className="detail-item quantity">
                                            <span className="detail-value">x1</span>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* <div className="warehouse-section">
                                <div className="warehouse-input-section">
                                    <input type="text" placeholder="Kiểm tra mã lưu kho/dòng áo" value={warehouseCode} onChange={(e) => setWarehouseCode(e.target.value)} className="warehouse-input" />
                                    <button onClick={handleWarehouseCheck} className="check-button">
                                        Kiểm tra
                                    </button>
                                </div>

                                <div className="warehouse-location-title">Vị trí - Mã lưu kho</div>

                                <div className="warehouse-tags">
                                    {warehouseLocations.map((location, index) => (
                                        <div key={index} className={`warehouse-tag ${location.active ? "active" : ""}`}>
                                            {location.code}
                                        </div>
                                    ))}
                                </div>
                            </div> */}
                            <div className="modal-actions">
                                <button
                                    onClick={() => {
                                        handlePrintLabelAndStorage();
                                    }}
                                    className="print-button"
                                >
                                    <span className="button-icon">
                                        <i className="fa fa-print"></i>
                                    </span>
                                    In tem lưu kho
                                </button>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        let dt = [...selectedProducts];
                                        let activeIndex = dt.findIndex((p) => p.isActive);
                                        if (activeIndex < dt.length - 1) {
                                            dt[activeIndex].isActive = false; // Deactivate current product
                                            dt[activeIndex + 1].isActive = true; // Activate next product
                                            setSelectedProducts(dt);
                                        }
                                    }}
                                    className="next-button"
                                >
                                    Tiếp theo
                                </button>
                            </div>
                        </div>

                        <div className="right-section">
                            {/* <div className="type-legend">
                                <div className="legend-item">
                                    <span className="legend-label">Loại nhóm:</span>
                                    <span className="legend-tag good">Tốt</span>
                                    <span className="legend-tag warning">Đợi sửa</span>
                                    <span className="legend-tag error">Không thể sửa</span>
                                </div>
                            </div> */}

                            <div className="products-table">
                                <div className="table-header">
                                    <div className="header-cell">Nhóm</div>
                                    <div className="header-cell">Hình ảnh</div>
                                    <div className="header-cell">Sản phẩm</div>
                                    <div className="header-cell">SL</div>
                                    <div className="header-cell">Trạng thái</div>
                                </div>

                                <div className="table-body">
                                    {selectedProducts && selectedProducts.length > 0 ? (
                                        selectedProducts.map((product, index) => (
                                            <div key={product.id} className={`table-row ${product.isActive ? "active" : ""}`}>
                                                <div className="cell group-number">{index + 1}</div>
                                                <div className="cell product-images">
                                                    {product.frontImage && <img src={product.frontImage} alt={`${product.name} 1`} />}
                                                    {product.backImage && <img src={product.backImage} alt={`${product.name} 2`} />}
                                                </div>
                                                <div className="cell product-info">
                                                    <div className="product-name">{product.appProductName}</div>
                                                    {/* <div className="product-type">{product.type}</div> */}
                                                    <div className="product-variant">
                                                        Size: {product.size}, Màu: {product.color}
                                                    </div>
                                                </div>
                                                <div className="cell quantity-badge">
                                                    <span className={`quantity-number ${product.status === "pending" ? "pending" : "completed"}`}>{product.quantityReceived}</span>
                                                </div>
                                                <div className="cell status-cell">
                                                    <span className={`status-text ${product.status}`}>{product.barcodeUrl !== "" ? "Đã in" : "Đợi in"}</span>
                                                    {product.barcodeUrl !== "" && (
                                                        <button
                                                            onClick={() => {
                                                                handlePrintPDF(product.barcodeUrl);
                                                            }}
                                                            className="reprint-button"
                                                        >
                                                            In lại
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="no-products">Không có sản phẩm nào được chọn</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default PrintReturnLabelModal;

const Wrapper = styled.div`
    .modal-content-custom {
        display: flex;
    }

    .product-showcase .product-images img {
        width: 220px;
        height: 220px;
        object-fit: contain;
    }

    .modal-container {
        width: 1200px;
        max-width: 95vw;
        max-height: 90vh;
        background: #f8f9fa;
        border-radius: 12px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .modal-header {
        background: #64c5b1;
        padding: 16px 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: white;
    }

    .modal-title {
        font-size: 18px;
        font-weight: 600;
        margin: 0;
        font-family: "Roboto", sans-serif;
    }

    .close-button {
        background: none;
        border: none;
        color: white;
        font-size: 24px;
        cursor: pointer;
        padding: 0;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .close-button:hover {
        opacity: 0.8;
    }

    .modal-content {
        display: flex;
        flex: 1;
        overflow: hidden;
    }

    .left-section {
        flex: 1;
        padding: 20px;
        background: white;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .instruction-text {
        font-size: 14px;
        color: #666;
        font-family: "Roboto", sans-serif;
    }

    .group-info-section {
        background: #e8f5e8;
        padding: 12px 16px;
        border-radius: 8px;
        border: 1px solid #d4edda;
    }

    .group-header {
        display: flex;
        align-items: center;
        gap: 8px;
        font-family: "Roboto", sans-serif;
    }

    .group-label {
        font-size: 14px;
        font-weight: 600;
        color: #333;
    }

    .group-number {
        font-size: 18px;
        font-weight: 700;
        color: #333;
    }

    .group-status {
        font-size: 18px;
        font-weight: 700;
        color: #28a745;
    }

    .product-showcase {
        background: white;
        border: 1px solid #e9ecef;
        border-radius: 8px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .product-images {
        display: flex;
        gap: 12px;
        justify-content: center;
    }

    .product-images img {
        width: 180px;
        height: 180px;
        object-fit: cover;
        border-radius: 8px;
        border: 1px solid #e9ecef;
    }

    .product-title {
        font-size: 14px;
        color: #333;
        text-align: center;
        font-family: "Roboto", sans-serif;
    }

    .product-details {
        display: flex;
        gap: 0;
        border: 1px solid #e9ecef;
        border-radius: 8px;
        overflow: hidden;
    }

    .detail-item {
        padding: 12px 16px;
        background: white;
        border-right: 1px solid #e9ecef;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: "Roboto", sans-serif;
    }

    .detail-item:last-child {
        border-right: none;
    }

    .detail-item:nth-child(1) {
        flex: 2;
    }

    .detail-item:nth-child(2) {
        flex: 1.5;
    }

    .detail-item.size,
    .detail-item.quantity {
        flex: 1;
    }

    .detail-label {
        font-size: 14px;
        font-weight: 600;
        color: #333;
    }

    .detail-value {
        font-size: 24px;
        font-weight: 700;
        color: #333;
    }

    .warehouse-section {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .warehouse-input-section {
        display: flex;
        gap: 12px;
    }

    .warehouse-input {
        flex: 1;
        padding: 12px 16px;
        border: 1px solid #e9ecef;
        border-radius: 6px;
        font-size: 14px;
        font-family: "Roboto", sans-serif;
    }

    .warehouse-input::placeholder {
        color: #999;
    }

    .check-button {
        padding: 12px 24px;
        background: #495057;
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        font-family: "Roboto", sans-serif;
    }

    .check-button:hover {
        background: #343a40;
    }

    .warehouse-location-title {
        font-size: 14px;
        color: #333;
        font-family: "Roboto", sans-serif;
    }

    .warehouse-tags {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    }

    .warehouse-tag {
        padding: 8px 12px;
        background: white;
        border: 1px solid #e9ecef;
        border-radius: 4px;
        font-size: 14px;
        color: #333;
        font-family: "Roboto", sans-serif;
    }

    .warehouse-tag.active {
        background: #28a745;
        color: white;
        border-color: #28a745;
    }

    .right-section {
        flex: 1.5;
        background: #f8f9fa;
        display: flex;
        flex-direction: column;
    }

    .type-legend {
        padding: 16px 20px;
        background: white;
        border-bottom: 1px solid #e9ecef;
    }

    .legend-item {
        display: flex;
        align-items: center;
        gap: 12px;
        font-family: "Roboto", sans-serif;
    }

    .legend-label {
        font-size: 14px;
        color: #333;
    }

    .legend-tag {
        padding: 4px 12px;
        border-radius: 16px;
        font-size: 12px;
        color: white;
        font-weight: 500;
    }

    .legend-tag.good {
        background: #28a745;
    }

    .legend-tag.warning {
        background: #8a38f5;
    }

    .legend-tag.error {
        background: #dc3545;
    }

    .products-table {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .table-header {
        display: flex;
        background: #e9ecef;
        border-bottom: 1px solid #dee2e6;
        font-family: "Roboto", sans-serif;
    }

    .header-cell {
        padding: 12px 16px;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        border-right: 1px solid #dee2e6;
    }

    .header-cell:nth-child(1) {
        width: 60px;
    }
    .header-cell:nth-child(2) {
        width: auto;
    }
    .header-cell:nth-child(3) {
        flex: 1;
    }
    .header-cell:nth-child(4) {
        width: 80px;
    }
    .header-cell:nth-child(5) {
        width: 120px;
    }
    .header-cell:last-child {
        border-right: none;
    }

    .table-body {
        flex: 1;
        overflow-y: auto;
    }

    .table-row {
        display: flex;
        border-bottom: 1px solid #e9ecef;
        background: white;
        min-height: 80px;
    }

    .table-row.active {
        background: #fff3cd;
    }

    .cell {
        padding: 12px 16px;
        display: flex;
        align-items: center;
        border-right: 1px solid #e9ecef;
        font-family: "Roboto", sans-serif;
    }

    .cell:nth-child(1) {
        width: 60px;
        justify-content: center;
    }
    .cell:nth-child(2) {
        width: auto;
    }
    .cell:nth-child(3) {
        flex: 1;
    }
    .cell:nth-child(4) {
        width: 80px;
        justify-content: center;
    }
    .cell:nth-child(5) {
        width: 120px;
    }

    .cell.group-number {
        border-left: 1px solid rgb(233, 236, 239);
    }

    .cell:last-child {
        border-right: 1px solid rgb(233, 236, 239);
    }

    .group-number {
        font-size: 14px;
        color: #333;
    }

    .product-images {
        display: flex;
        gap: 4px;
        position: relative;
    }

    .product-images img {
        width: 70px;
        height: 70px;
        object-fit: cover;
        border-radius: 4px;
        border: 1px solid #e9ecef;
    }

    .product-info {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }

    .product-name {
        font-size: 12px;
        color: #333;
        line-height: 1.3;
    }

    .product-type {
        font-size: 12px;
        font-weight: 600;
        color: #333;
    }

    .product-variant {
        font-size: 12px;
        font-weight: 600;
        color: #333;
    }

    .quantity-badge {
        justify-content: center;
    }

    .quantity-number {
        width: 32px;
        height: 24px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 600;
        color: white;
    }

    .quantity-number.completed {
        background: #28a745;
    }

    .quantity-number.pending {
        background: #8a38f5;
    }

    .status-cell {
        flex-direction: column;
        gap: 8px;
    }

    .status-text {
        font-size: 12px;
        font-weight: 500;
    }

    .status-text.printed {
        color: #28a745;
    }

    .status-text.pending {
        color: #dc3545;
    }

    .reprint-button {
        padding: 4px 8px;
        background: #495057;
        color: white;
        border: none;
        border-radius: 4px;
        font-size: 11px;
        cursor: pointer;
        font-family: "Roboto", sans-serif;
    }

    .reprint-button:hover {
        background: #343a40;
    }

    .modal-actions {
        display: flex;
        gap: 16px;
        padding: 20px;
        background: white;
        border-top: 1px solid #e9ecef;
    }

    .print-button {
        flex: 1;
        padding: 12px 24px;
        background: #64c5b1;
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-family: "Roboto", sans-serif;
    }

    .print-button:hover {
        background: #57b3a0;
    }

    .next-button {
        padding: 12px 32px;
        background: #495057;
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        font-family: "Roboto", sans-serif;
    }

    .next-button:hover {
        background: #343a40;
    }

    .button-icon {
        font-size: 16px;
    }

    /* Responsive design */
    @media (max-width: 768px) {
        .modal-container {
            width: 95vw;
            height: 95vh;
        }

        .modal-content {
            flex-direction: column;
        }

        .left-section,
        .right-section {
            flex: none;
        }

        .product-images {
            flex-direction: column;
            align-items: center;
        }

        .product-images img {
            width: 150px;
            height: 150px;
        }

        .modal-actions {
            flex-direction: column;
        }
    }
`;
